import { atsApiQuery } from '..';

export const eSignsApiApi = atsApiQuery.injectEndpoints({
  endpoints: (builder) => ({
    getDefaultESign: builder.query({
      providesTags: ['getDefaultESign'],
      transformResponse: (response) => response?.data,
      query: ({ id, integration_type, job_id }) => {
        const params = {
          integration_type,
          id,
          job_id,
        };

        return {
          method: 'get',
          url: '/esign_envelopes/default',
          params,
        };
      },
      staleTime: 0,
    }),

    getSignSequence: builder.query({
      transformResponse: (response) => response?.data,
      query: ({ id }) => ({
        method: 'get',
        url: `/esign_envelopes/${id}/signing_sequence`,
      }),
      staleTime: 0,
    }),

    updateDefaultESign: builder.mutation({
      transformResponse: (response) => response?.data,
      query: ({ id, type, payload, integration_type }) => {
        const params = {
          integration_type,
          id,
          type,
        };

        return {
          method: 'put',
          url: '/esign_envelopes/default',
          params,
          data: payload,
        };
      },
    }),

    sendDocuSignRemainder: builder.mutation({
      transformResponse: (response) => response?.data,
      query: ({ id }) => ({
        method: 'post',
        url: `/esign_envelopes/${id}/send_reminder`,
      }),
    }),

    voidESignEnvelope: builder.mutation({
      transformResponse: (response) => response?.data,
      query: ({ id, voided_reason }) => ({
        method: 'post',
        url: `/esign_envelopes/${id}/void`,
        data: { voided_reason },
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetDefaultESignQuery,
  useUpdateDefaultESignMutation,
  useLazyGetSignSequenceQuery,
  useSendDocuSignRemainderMutation,
  useVoidESignEnvelopeMutation,
} = eSignsApiApi;
